import React from 'react';

const MapRecenterButton = ({ onClick, title = 'Ver todo el mapa' }) => (
  <button
    type="button"
    className="map-recenter-button"
    onClick={onClick}
    title={title}
    aria-label={title}
    style={{
      position: 'absolute',
      top: 56,
      right: 10,
      zIndex: 1000,
      width: 40,
      height: 40,
      padding: 0,
      border: 'none',
      borderRadius: 2,
      backgroundColor: '#fff',
      boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8" cy="10" r="1.5" fill="#666" stroke="none" />
      <circle cx="16" cy="9" r="1.5" fill="#666" stroke="none" />
      <circle cx="12" cy="15" r="1.5" fill="#666" stroke="none" />
    </svg>
  </button>
);

export default MapRecenterButton;
